import * as data from './assets/app-config.json';
import { FirebaseService } from './firebase.service';
import { LocalService } from './local.service';
import { MarketPlaceConfig, Resources, userManagementKey } from './models';
import { BehaviorSubject, Subject } from 'rxjs';
const tenants_list_output_event: BehaviorSubject<string> = new BehaviorSubject<string>('');
const config_vetting_process_event: BehaviorSubject<string> = new BehaviorSubject<string>('');
const route_change_event: BehaviorSubject<string> = new BehaviorSubject<string>('');

const tenant_configuration_event: BehaviorSubject<any> = new BehaviorSubject<any>('');

const tenant_configuration_hero_form_dirty_event: BehaviorSubject<any> = new BehaviorSubject<any>('');

const tenant_refresh_logo_event: Subject<any> = new Subject<any>();

export const DEFAULT_TENANT_LOGO_URL =
  'https://storage.googleapis.com/g-saas.appspot.com/tenants/registration/tenant_logo_placeholder_1740984110001.png';

export const {
  SENTRY_DSN,
  VERSION,
  G_SASS_API,
  FIREBASE_CONFIG,
  MSG91OTPWidget,
  GrowBookApiKey,
  GrowBookApiHost,
  HUBSPOT_TRACKING_ID,
  GOOGLE_TAG_ID,
  OREILLY_URL,
  EDX_URL,
  EDX_SSO_MS_PERSONAL_URL,
  EDX_SSO_MS_WORK_SCHOOL_URL,
  GOOGLE_RECAPTCHA_SITE_KEY,
} = { ...data };

export const G_SASS_API_URL = `${G_SASS_API}/${VERSION}`;

export const getLocalData = (key: string) => {
  return LocalService.getData(key);
};

export const saveLocalData = (key: string, data: any) => {
  LocalService.saveData(key, data);
};

export const removeLocalData = (key: string) => {
  LocalService.removeData(key);
};

export const clearLocalData = () => {
  LocalService.clearData();
};

export const encrypt = (data: any) => {
  return LocalService.encrypt(data);
};

export const decrypt = (data: any) => {
  return LocalService.decrypt(data);
};

export const refreshToken = () => {
  return FirebaseService.refreshToken();
};

export function get_tenants_list_event_as_observable() {
  return tenants_list_output_event.asObservable();
}

export function tenants_list_event_emit_value(param: string) {
  return tenants_list_output_event.next(param);
}

export function route_change_event_as_observable() {
  return route_change_event.asObservable();
}

export function route_change_event_as_value(route: string) {
  return route_change_event.next(route);
}

setInterval(() => {
  FirebaseService.refreshToken();
}, 300000);

export const DATE_REGULAR_EXPRESSIONS = [
  {
    format: 'ISO 8061',
    expression: /^(?:\d{4})-(?:\d{2})-(?:\d{2})T(?:\d{2}):(?:\d{2}):(?:\d{2}(?:\.\d*)?)(?:(?:-(?:\d{2}):(?:\d{2})|Z)?)$/,
  },
  { format: 'yyyy-mm-dd', expression: /^(?:\d{4})-(?:\d{2})-(?:\d{2})$/ },
];

export const formatDate = (date: Date): string => {
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = date.toLocaleDateString('en-US', { day: 'numeric' });
  const year = date.toLocaleDateString('en-US', { year: 'numeric' });

  return `${month} ${day}, ${year}`;
};

export const transformData = (serviceRequestElement: any) => {
  if (DATE_REGULAR_EXPRESSIONS.some(re => re.expression.test(serviceRequestElement))) {
    return formatDate(new Date(serviceRequestElement));
  }
  return serviceRequestElement;
};

export const isCognito = (marketPlaceConfig: MarketPlaceConfig) => {
  const cognitoCompanies = ['MICROSOFT', 'SAFARICOM', 'AWS', 'I-CAPITAL', 'NVIDIA'];
  return cognitoCompanies.some(company => company.toLowerCase() === marketPlaceConfig?.platformConfiguration?.companyCode?.toLowerCase());
};

export function config_vetting_process_event_as_observable() {
  return config_vetting_process_event.asObservable();
}

export function config_vetting_process_event_emit_value(param: string) {
  return config_vetting_process_event.next(param);
}

export function tenant_configuration_event_as_observable() {
  return tenant_configuration_event.asObservable();
}

export function tenant_configuration_event_emit_value(param: string) {
  return tenant_configuration_event.next(param);
}

export function tenant_configuration_hero_section_dirty_event_as_observable() {
  return tenant_configuration_hero_form_dirty_event.asObservable();
}

export function tenant_configuration_hero_section_dirty_event_emit_value(param: string) {
  return tenant_configuration_hero_form_dirty_event.next(param);
}
export function tenant_refresh_logo_event_event_as_observable() {
  return tenant_refresh_logo_event.asObservable();
}

export function tenant_refresh_logo_event_emit_value(param: any) {
  return tenant_refresh_logo_event.next(param);
}

export const SAAS_ADMIN_STORAGE_KEY = 'user-data-storage-key';

export const MARKETPLACE_CONFIG_STORAGE_KEY = 'market_place_config';
export const SERVICE_BUYER_STORAGE_KEY = 'g-saas-service-buyer';
export const DEACTIVATED_USER_STORAGE_KEY = '34d4cf740348a3ad9a6d5b2603d7e812';
export const MARKETPLACE_USER_STORAGE_KEY = 'user_data';
export const GIG_WORKER_STORAGE_KEY = 'g-saas-gig-worker';
export const PAYMENT_STATUS_STORAGE_KEY = `U2FsdGVkX1+y7rN1I0hgsT6HFzsOFODNOkA5k6UcWeQSPHD8wIiQonECFm6bMGUc`;
export const PAYMENT_SUCCESS_STORAGE_KEY = `U2FsdGVkX19qrwA21k+bqkWwaIWQoxtZCDFcF3UIr24=`;
export const G_SAAS_REALM = 'g-saas-realm';

export enum G_SAAS_REALM_TYPE {
  AdminTenant = 'AdminTenant',
  AdminSaaS = 'AdminSaaS',
}

export const getPermission = (service: string) => {
  const savedService = getLocalData(userManagementKey.permission);
  if (!savedService) return [];
  const filteredService = savedService?.filter(s => s.name === service);

  return filteredService.map((fs: any) => fs.name + '-' + fs.accessPermission);
};

export const setPermission = (data: Resources) => {
  saveLocalData(userManagementKey.permission, JSON.stringify(data));
};

export enum Services {
  //Admin SaaS services

  Affiliate = 'affiliate_programs',
  Sponsor = 'sponsorship',
  UserManagement = 'user_management',
  Forms = 'forms',
  Tenant = 'tenants',
  Dashboard = 'dashboard',
  GigWorkerDashboard = 'gigworker_dashboard',
  GigWorkerDashboardInternal = 'gigworker_dashboard_internal',
  GenerateReport = 'generate_report',
  SubmitReport = 'submit_report',
  TenantReportingStatus = 'tenant_reporting_status',

  // Admin Tenant services

  ServiceProviders = 'service_providers',
  ServiceBuyers = 'service_buyers',
  ServiceRequests = 'service_requests',
  ProfileRequests = 'profile_requests',
  ServiceOffers = 'service_offers',
  Vetting = 'vetting',
  Agreement = 'agreement',
  Payment = 'payment',
  ServiceProviderReport = 'service_provider_report',
  Coaches = 'coaches',
  CoachesDashboard = 'coaches_dashboard',
  DeleteData = 'delete_data',
  Marketplace = 'marketplace',
  DomainSetup = 'domain_setup',
  Design = 'design',
  Services = 'services',
  Categories = 'categories',
  Signup = 'signup',
  TermsCondition = 'terms_condition',
  ServiceProvider = 'service_provider',
  VettingProcess = 'vetting_process',
  MarketplaceTemplate = 'templates',
}

export enum ServicesPermission {
  //Admin SaaS services

  AffiliateView = Services.Affiliate + '-ViewOnly',
  AffiliateViewAndEdit = Services.Affiliate + '-ViewAndEdit',
  AffiliateNone = Services.Affiliate + '-None',

  SponsorView = Services.Sponsor + '-ViewOnly',
  SponsorViewAndEdit = Services.Sponsor + '-ViewAndEdit',
  SponsorNone = Services.Sponsor + '-None',

  UserManagementView = Services.UserManagement + '-ViewOnly',
  UserManagementViewAndEdit = Services.UserManagement + '-ViewAndEdit',
  UserManagementNone = Services.UserManagement + '-None',

  FormsView = Services.Forms + '-ViewOnly',
  FormsViewAndEdit = Services.Forms + '-ViewAndEdit',
  FormsNone = Services.Forms + '-None',

  TenantNone = Services.Tenant + '-None',
  TenantView = Services.Tenant + '-ViewOnly',
  TenantViewAndEdit = Services.Tenant + '-ViewAndEdit',

  DashboardNone = Services.Dashboard + '-None',
  DashboardView = Services.Dashboard + '-ViewOnly',
  DashboardViewAndEdit = Services.Dashboard + '-ViewAndEdit',

  GigWorkerDashboardNone = Services.GigWorkerDashboard + '-None',
  GigWorkerDashboardView = Services.GigWorkerDashboard + '-ViewOnly',
  GigWorkerDashboardViewAndEdit = Services.GigWorkerDashboard + '-ViewAndEdit',

  GigWorkerDashboardInternalNone = Services.GigWorkerDashboardInternal + '-None',
  GigWorkerDashboardInternalView = Services.GigWorkerDashboardInternal + '-ViewOnly',
  GigWorkerDashboardInternalViewAndEdit = Services.GigWorkerDashboardInternal + '-ViewAndEdit',

  GenerateReportNone = Services.GenerateReport + '-None',
  GenerateReportView = Services.GenerateReport + '-ViewOnly',
  GenerateReportViewAndEdit = Services.GenerateReport + '-ViewAndEdit',

  SubmitReportNone = Services.SubmitReport + '-None',
  SubmitReportView = Services.SubmitReport + '-ViewOnly',
  SubmitReportViewAndEdit = Services.SubmitReport + '-ViewAndEdit',

  TenantReportingStatusNone = Services.TenantReportingStatus + '-None',
  TenantReportingStatusView = Services.TenantReportingStatus + '-ViewOnly',
  TenantReportingStatusViewAndEdit = Services.TenantReportingStatus + '-ViewAndEdit',

  // Admin Tenant services

  ServiceProvidersNone = Services.ServiceProviders + '-None',
  ServiceProvidersView = Services.ServiceProviders + '-ViewOnly',
  ServiceProvidersViewAndEdit = Services.ServiceProviders + '-ViewAndEdit',

  ServiceBuyersNone = Services.ServiceBuyers + '-None',
  ServiceBuyersView = Services.ServiceBuyers + '-ViewOnly',
  ServiceBuyersViewAndEdit = Services.ServiceBuyers + '-ViewAndEdit',

  ServiceRequestsNone = Services.ServiceRequests + '-None',
  ServiceRequestsView = Services.ServiceRequests + '-ViewOnly',
  ServiceRequestsViewAndEdit = Services.ServiceRequests + '-ViewAndEdit',

  ProfileRequestsNone = Services.ProfileRequests + '-None',
  ProfileRequestsView = Services.ProfileRequests + '-ViewOnly',
  ProfileRequestsViewAndEdit = Services.ProfileRequests + '-ViewAndEdit',

  ServiceOffersNone = Services.ServiceOffers + '-None',
  ServiceOffersView = Services.ServiceOffers + '-ViewOnly',
  ServiceOffersViewAndEdit = Services.ServiceOffers + '-ViewAndEdit',

  VettingNone = Services.Vetting + '-None',
  VettingView = Services.Vetting + '-ViewOnly',
  VettingViewAndEdit = Services.Vetting + '-ViewAndEdit',

  AgreementNone = Services.Agreement + '-None',
  AgreementView = Services.Agreement + '-ViewOnly',
  AgreementViewAndEdit = Services.Agreement + '-ViewAndEdit',

  PaymentNone = Services.Payment + '-None',
  PaymentView = Services.Payment + '-ViewOnly',
  PaymentViewAndEdit = Services.Payment + '-ViewAndEdit',

  ServiceProviderReportNone = Services.ServiceProviderReport + '-None',
  ServiceProviderReportView = Services.ServiceProviderReport + '-ViewOnly',
  ServiceProviderReportViewAndEdit = Services.ServiceProviderReport + '-ViewAndEdit',

  CoachesNone = Services.Coaches + '-None',
  CoachesView = Services.Coaches + '-ViewOnly',
  CoachesViewAndEdit = Services.Coaches + '-ViewAndEdit',

  CoachesDashboardNone = Services.CoachesDashboard + '-None',
  CoachesDashboardView = Services.CoachesDashboard + '-ViewOnly',
  CoachesDashboardViewAndEdit = Services.CoachesDashboard + '-ViewAndEdit',

  DeleteDataNone = Services.DeleteData + '-None',
  DeleteDataView = Services.DeleteData + '-ViewOnly',
  DeleteDataViewAndEdit = Services.DeleteData + '-ViewAndEdit',

  MarketplaceNone = Services.Marketplace + '-None',
  MarketplaceView = Services.Marketplace + '-ViewOnly',
  MarketplaceViewAndEdit = Services.Marketplace + '-ViewAndEdit',

  DomainSetupNone = Services.DomainSetup + '-None',
  DomainSetupView = Services.DomainSetup + '-ViewOnly',
  DomainSetupViewAndEdit = Services.DomainSetup + '-ViewAndEdit',

  DesignNone = Services.Design + '-None',
  DesignView = Services.Design + '-ViewOnly',
  DesignViewAndEdit = Services.Design + '-ViewAndEdit',

  ServicesNone = Services.Services + '-None',
  ServicesView = Services.Services + '-ViewOnly',
  ServicesViewAndEdit = Services.Services + '-ViewAndEdit',

  CategoriesNone = Services.Categories + '-None',
  CategoriesView = Services.Categories + '-ViewOnly',
  CategoriesViewAndEdit = Services.Categories + '-ViewAndEdit',

  SignupNone = Services.Signup + '-None',
  SignupView = Services.Signup + '-ViewOnly',
  SignupViewAndEdit = Services.Signup + '-ViewAndEdit',

  TermsConditionNone = Services.TermsCondition + '-None',
  TermsConditionView = Services.TermsCondition + '-ViewOnly',
  TermsConditionViewAndEdit = Services.TermsCondition + '-ViewAndEdit',

  ServiceProviderNone = Services.ServiceProvider + '-None',
  ServiceProviderView = Services.ServiceProvider + '-ViewOnly',
  ServiceProviderViewAndEdit = Services.ServiceProvider + '-ViewAndEdit',

  VettingProcessNone = Services.VettingProcess + '-None',
  VettingProcessView = Services.VettingProcess + '-ViewOnly',
  VettingProcessViewAndEdit = Services.VettingProcess + '-ViewAndEdit',

  MarketplaceTemplateNone = Services.MarketplaceTemplate + '-None',
  MarketplaceTemplateView = Services.MarketplaceTemplate + '-ViewOnly',
  MarketplaceTemplateViewAndEdit = Services.MarketplaceTemplate + '-ViewAndEdit',
}
